module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Manchester-add9e8b9d38caa329b21ee287fd1b03d.svg";